module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "loaded": _vm.loaded,
      "modal-title": _vm.dashboardId == null ? 'Create Dashboard' : 'Edit Dashboard'
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('h2', [_vm._v("Settings")]), _vm._v(" "), _c('FormulateForm', [_c('FormulateInput', {
    attrs: {
      "type": "text",
      "label": "Title"
    },
    on: {
      "input": function($event) {
        _vm.dirtyStatus.name = true
      }
    },
    model: {
      value: (_vm.dashboardModel.name),
      callback: function($$v) {
        _vm.$set(_vm.dashboardModel, "name", $$v)
      },
      expression: "dashboardModel.name"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "select",
      "label": "Date Field",
      "options": _vm.dateFields
    },
    on: {
      "input": function($event) {
        _vm.dirtyStatus.date_field = true
      }
    },
    model: {
      value: (_vm.dashboardModel.date_field),
      callback: function($$v) {
        _vm.$set(_vm.dashboardModel, "date_field", $$v)
      },
      expression: "dashboardModel.date_field"
    }
  })], 1), _vm._v(" "), _c('h2', [_vm._v("Filter Rule")]), _vm._v(" "), _c('boolean-expression-widget', {
    attrs: {
      "expression": _vm.dashboardModel.filter_rule
    },
    on: {
      "updateExpression": _vm.updateFilterRule
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Pivots")]), _vm._v(" "), _c('FormulateForm', [_c('table', {
    staticClass: "table table-noborder"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Field")]), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.dashboardModel.pivots), function(pivot, ix) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(pivot.name))]), _vm._v(" "), _c('td', [_c('FormulateInput', {
      attrs: {
        "type": "button",
        "label": "Remove"
      },
      on: {
        "click": function($event) {
          return _vm.removePivot(ix)
        }
      }
    })], 1)])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('FormulateInput', {
    attrs: {
      "type": "select",
      "name": "field",
      "options": _vm.availablePivots
    },
    model: {
      value: (_vm.pivotToAdd),
      callback: function($$v) {
        _vm.pivotToAdd = $$v
      },
      expression: "pivotToAdd"
    }
  })], 1), _vm._v(" "), _c('td', [_c('FormulateInput', {
    staticClass: "add",
    attrs: {
      "type": "button",
      "label": "Add"
    },
    on: {
      "click": _vm.addPivot
    }
  })], 1)])], 2)])]), _vm._v(" "), (_vm.dashboardModel.id) ? _c('h2', [_vm._v("Advanced")]) : _vm._e(), _vm._v(" "), (_vm.dashboardModel.id) ? _c('div', {
    staticClass: "advanced"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.cloneDashboard
    }
  }, [_c('i', {
    staticClass: "fa fa-clone"
  }), _vm._v(" Clone Dashboard")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.removeDashboard
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Remove Dashboard")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-580fb784"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/DashboardModal.vue
// module id = 652
// module chunks = 0